// Copyright (c) 2019 Deere & Company

import './index.scss';
import * as busyCounter from '../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../shared/action-creator/alert-messages';
import { generateClaimPDF, getClaimDetails, updateClaimDataByMode } from './repositories';
import Accordion from '../app/common/components/accordion';
import Attachment from './components/attachment';
import BasicClaimInfo from './components/basic';
import BusyCounterLoadingIndicator from '../shared/components/busyCounter/busy-counter-loading-indicator';
import ClaimAnalysis from './components/claim-analysis';
import ClaimAuditMessages from './components/audit-messages';
import ClaimDetailsHeader from './components/claim-details-header';
import ClaimRelatedDetails from './components/claim-related-details';
import ComponentFunctionCodeDetails from './components/component-function-code-details';
import { ConfirmationModal } from '../shared/components/modals/confirmation-modal';
import FunctionCodeDetails from './components/function-code';
import MachineWarranty from './components/machine-warranty';
import PrimePartInfo from './components/prime-part';
import PropTypes from 'prop-types';
import ReplaceMentPart from './components/replacement-part';
import SupplierInformation from './components/supplier-information';
import { connect } from 'react-redux';
import { convertUnixtodate } from '../shared/services/common-functions';
import { showLoadingIndicator } from '../shared/state/busy-counter';


class ClaimDetails extends Component {

    state = {
        claimPartDetails: {},
        claimDetails: {},
        claimAttachments: {},
        claimAuditMessages: {},
        claimEditable: false,
        isClaimEditable: false,
        componentEditEnable: '',
        confirmIsOpen: false,
        needSupplierInfoUpdate: false,
        userDesiredLng: '',
        showLoader: false,
    };

    nextEvent = '';

    componentWillMount () {
        console.log("componentWillMount");
            console.log("this.props.warrantyClaimId : : ",this.props.warrantyClaimId);
          console.log("this.props.selectedClaimNumber : : ",this.props.selectedClaimNumber);
          console.log("this.props.claimDetailsInfo : : ",this.props.claimDetailsInfo);

        this.getDetailClaim( this.props.warrantyClaimId );

    }

    componentDidMount () {
console.log("componentDidMount:::");
        this.props.decreaseCounter();

    }

    componentWillReceiveProps ( nextProps ) {
        console.log("componentWillReceiveProps");

        if ( nextProps.warrantyClaimId !== this.props.warrantyClaimId ) {
            this.setState({showLoader:true})
            this.getDetailClaim( nextProps.warrantyClaimId );

        }

    }

    claimTextEdit = () => {

    }

    updateSupplierInfo = () => {

        this.setState( {
            needSupplierInfoUpdate: !this.state.needSupplierInfoUpdate,
        } );

    }

    getDetailClaim = warrantyClaimId => {
    console.log("callFrom ##########:: ",this.props.callFrom);

        const claimDetailsToFetch = [
            'claimDetails',
            'claimPartDetails',
            'claimAttachments',
        ];
        let isClaimEditable;
        let respo = [];

        if (this.props.callFrom === 'workList') {
            console.log("workList -----")
            claimDetailsToFetch.push('claimAuditMessages');
        }

        this.setState( { showLoader: true } );

        const detailPromises = claimDetailsToFetch.map( details => {

           // this.props.increaseCounter();
           console.log("claimDetailsToFetch()");

            return getClaimDetails( details, warrantyClaimId ).then( response => {

                if ( response.length > 0 ) {

                    respo = details === 'claimAuditMessages' ||
                    details === 'claimAttachments' ? response : response[0];

                    console.log("response.length ---------",response)

                } else {
                    respo = {};
                    console.log("response.length ---------",response)
                }

                if ( details === 'claimDetails' ) {
                    console.log("details === claimDetails ---------",response)

                    isClaimEditable = response[0] === undefined ?
                        this.state.isClaimEditable : response[0].claimEditable;
                    this.setState( {
                        [details]: respo,
                        isClaimEditable,
                    } );



                } else {
                    console.log("ELSE details === claimDetails ---------",response)
                    this.setState( {
                        [details]: respo,
                    } );
                }

                //this.props.decreaseCounter();
                console.log("state:: ",this.state);

                console.log("showLoader1::",this.state.showLoader);
            } ).catch( () => {
                // Continue loading other sections; final loader state is handled after all requests settle.
            } );

        } );

        Promise.allSettled( detailPromises ).finally( () => {

            this.setState( { showLoader: false } );

        } );

    }

    updateClaimData = ( mode, updatedData ) => {
        console.log("update claim details::");
        this.setState({showLoader:true})
        const { warrantyClaimId } = this.state.claimDetails;
        updateClaimDataByMode( mode, warrantyClaimId, updatedData ).then( () => {

            this.getDetailClaim( this.state.claimDetails.warrantyClaimId );
            this.setState( {
                componentEditEnable: '',
            } );

            if ( mode === 'primePartFailure' ) {

                this.updateSupplierInfo();

            }

        } ).catch( () => {

            this.setState({showLoader:false})
        } );

    }

    getPreviousClaimDetails = () => {

        if ( this.state.componentEditEnable !== '' ) {

            this.nextEvent = 'previousClaim';
            this.setState( {
                confirmIsOpen: true,
            } );

        } else {

            this.props.getPreviousClaimDetails();

        }

    }

    getNextClaimDetails = () => {

        if ( this.state.componentEditEnable !== '' ) {

            this.nextEvent = 'nextClaim';
            this.setState( {
                confirmIsOpen: true,
            } );

        } else {

            this.props.getNextClaimDetails();

        }

    }

    handleConfirmClose = () => {

        this.setState( {

            confirmIsOpen: false,

        } );

    };

    getNextEvent = () => {

        switch ( this.nextEvent ) {

        case 'previousClaim': this.props.getPreviousClaimDetails(); break;
        case 'nextClaim': this.props.getNextClaimDetails(); break;
        default: this.enableEditCmp( this.nextEvent );

        }

    }

    handleConfirm = () => {

        this.setState( {
            componentEditEnable: '',
            confirmIsOpen: false,
        }, () => {

            this.getNextEvent();

        } );

    }

    handlePrintClick = () => {

        this.setState( { showLoader: true } );
        generateClaimPDF( this.state.claimDetails.warrantyClaimId ).then( response => {

            response.blob().then( blob => {

                const file = new Blob( [blob], { type: 'application/pdf' } );
                const fileUrl = URL.createObjectURL( file );
                window.open( fileUrl );

            } );

        } ).catch( () => {

        } ).finally( () => {

            this.setState( { showLoader: false } );

        } );

    }

    updateLanguage = userLanguage => {

        this.setState( {
            userDesiredLng: userLanguage,
        } );

    }

    enableEditCmp ( cmpName ) {

        if ( this.state.componentEditEnable !== '' &&
            this.state.componentEditEnable !== cmpName ) {

            this.setState( {
                confirmIsOpen: true,
            } );
            this.nextEvent = cmpName;
            return false;

        } if ( this.state.componentEditEnable === cmpName ) {

            this.setState( {
                componentEditEnable: '',
            } );
            return true;

        }

        this.setState( {
            componentEditEnable: cmpName,
        } );
        return true;


    }


    render () {
        console.log("selectedClaimNumber : ",this.props.selectedClaimNumber);
        console.log("claimDetailsInfo : ",this.props.claimDetailsInfo);
        console.log("callfrom  : ",this.props.callFrom);


        return (
            <div>
                <ClaimDetailsHeader
                    selectedClaimNumber={this.props.selectedClaimNumber}
                    claimDetailsInfo={this.props.claimDetailsInfo}
                    onBackToResult={this.props.onBackToResult}
                    getPreviousClaimDetails={this.getPreviousClaimDetails}
                    getNextClaimDetails={this.getNextClaimDetails}
                    handlePrintClick={this.handlePrintClick}
                    callFrom={this.props.callFrom}
                />
                <div className="claim-sections">
                    <section>
                    <BusyCounterLoadingIndicator busyCounter={this.state.showLoader} />

                        <section className="claim-header-section">
                            <div>
                                <label>Factory Code:</label>
                                <span>{`${this.state.claimDetails.analysisFactoryCode
                                } - ${this.state.claimDetails.analysisFactoryCodeDescription}`}
                                </span>
                            </div>
                            <div>
                                <label>Claim Sequence No:</label>
                                <span>{this.state.claimDetails.warrantyClaimId}</span>
                            </div>
                            <div>
                                <label>Load TimeStamp:</label>
                                <span>
                                    { convertUnixtodate( this.state.claimDetails.loadedDate )
                                    }
                                </span>
                            </div>
                            <div>
                                <label>Last Updated Date:</label>
                                <span>
                                    { convertUnixtodate( this.state.claimDetails.lastScrubbedDate )}
                                </span>
                            </div>
                            <div>
                                <label>Last Updated By:</label>
                                <span>{this.state.claimDetails.lastScrubbedBy}</span>
                            </div>

                        </section>


                        {this.props.callFrom === 'workList' && this.state.claimAuditMessages
                            && Object.keys( this.state.claimAuditMessages ).length > 0 && (
                            <Accordion
                                accordionId="audit-claim-information"
                                title="Claim Audit Messages"
                                isExpanded={true}
                            >
                                <ClaimAuditMessages
                                    auditMessages={this.state.claimAuditMessages}
                                    isComponentEdit={true}
                                    updateClaim={this.updateClaimData.bind( this )}
                                    enableEditCmp={this.enableEditCmp.bind( this )}
                                    isEdit={this.state.componentEditEnable === 'Audit Messages'}
                                />
                            </Accordion>
                        )}
                        <Accordion
                            accordionId="basic-claim-information"
                            title="Basic Claim"
                            isExpanded={this.state.claimDetails &&
                                Object.keys( this.state.claimDetails ).length > 0}
                        >

                            <BasicClaimInfo
                                claimDetails={this.state.claimDetails}
                                updateClaim={this.updateClaimData.bind( this )}
                                isComponentEdit={this.state.isClaimEditable}
                                enableEditCmp={this.enableEditCmp.bind( this )}
                                isEdit={this.state.componentEditEnable === 'Basic Claim'}
                            />

                        </Accordion>
                        <Accordion
                            accordionId="basic-claim-information"
                            title="Machine Warranty"
                            isExpanded={this.state.claimDetails &&
                                Object.keys( this.state.claimDetails ).length > 0}
                        >

                            <MachineWarranty
                                claimDetails={this.state.claimDetails}
                                isComponentEdit={this.state.isClaimEditable}
                                updateClaim={this.updateClaimData.bind( this )}
                                enableEditCmp={this.enableEditCmp.bind( this )}
                                isEdit={this.state.componentEditEnable === 'Machine Warranty'}
                            />

                        </Accordion>

                        <Accordion
                            accordionId="basic-claim-information"
                            title="Prime Part Failure"
                            isExpanded={false}
                        >
                            <PrimePartInfo
                                claimPartDetails={this.state.claimPartDetails}
                                updateClaim={this.updateClaimData.bind( this )}
                                isComponentEdit={this.state.isClaimEditable}
                                enableEditCmp={this.enableEditCmp.bind( this )}
                                isEdit={this.state.componentEditEnable === 'Prime Part Failure'}
                            />

                        </Accordion>
                        {this.state.claimAttachments &&
                            Object.keys( this.state.claimAttachments ).length > 0 && (
                            <Accordion
                                accordionId="basic-claim-information"
                                title="Claim Attachments"
                                isExpanded={false}
                            >
                                <Attachment
                                    attachments={this.state.claimAttachments}
                                />

                            </Accordion>
                        )}

                        <Accordion
                            accordionId="basic-claim-information"
                            title="Function Codes"
                            isExpanded={false}
                        >
                            <FunctionCodeDetails
                                claimPartDetails={this.state.claimPartDetails}
                                updateClaim={this.getDetailClaim.bind( this )}
                                claimNumber={this.state.claimDetails.warrantyClaimId}
                                isComponentEdit={this.state.isClaimEditable}
                                enableEditCmp={this.enableEditCmp.bind( this )}
                                isEdit={this.state.componentEditEnable === 'Function Codes'}
                            />
                        </Accordion>

                        <Accordion
                            accordionId="Supplier-claim-information"
                            title="Supplier Information"
                            isExpanded={false}
                        >
                            <SupplierInformation
                                claimFor="claimSupplierInformation"
                                claimNumber={this.props.selectedClaimNumber}
                                isComponentEdit={false}
                                needSupplierInfoUpdate={this.state.needSupplierInfoUpdate}
                            />
                        </Accordion>

                        <Accordion
                            accordionId="basic-claim-information"
                            title="Component Codes"
                            isExpanded={false}
                        >
                            <ComponentFunctionCodeDetails
                                claimPartDetails={this.state.claimPartDetails}
                                updateClaim={this.updateClaimData.bind( this )}
                                isComponentEdit={this.state.isClaimEditable}
                                enableEditCmp={this.enableEditCmp.bind( this )}
                                isEdit={this.state.componentEditEnable === 'Component Codes'}
                            />
                        </Accordion>

                        <Accordion
                            accordionId="basic-claim-information"
                            title="Complaint"
                            isExpanded={false}
                        >
                            <ClaimRelatedDetails
                                claimFor="claimComplaint"
                                claimNumber={this.state.claimDetails.warrantyClaimId}
                                claimTextEdit={this.state.claimDetails.primePartDetailText}
                                isComponentEdit={false}
                                userDesiredLng={this.state.userDesiredLng}
                                handleLanguage={this.updateLanguage.bind( this )}
                            />
                        </Accordion>
                        <Accordion
                            accordionId="basic-claim-information"
                            title="Cause"
                            isExpanded={false}
                        >
                            <ClaimRelatedDetails
                                claimFor="claimCause"
                                claimNumber={this.state.claimDetails.warrantyClaimId}
                                claimTextEdit={this.claimTextEdit.bind( this )}
                                isComponentEdit={false}
                                userDesiredLng={this.state.userDesiredLng}
                                handleLanguage={this.updateLanguage.bind( this )}
                            />
                        </Accordion>
                        <Accordion
                            accordionId="basic-claim-information"
                            title="Correction"
                            isExpanded={false}
                        >
                            <ClaimRelatedDetails
                                claimFor="claimCorrection"
                                claimNumber={this.state.claimDetails.warrantyClaimId}
                                claimTextEdit={this.claimTextEdit.bind( this )}
                                isComponentEdit={false}
                                userDesiredLng={this.state.userDesiredLng}
                                handleLanguage={this.updateLanguage.bind( this )}
                            />
                        </Accordion>
                        <Accordion
                            accordionId="basic-claim-information"
                            title="Settlement"
                            isExpanded={false}
                        >
                            <ClaimRelatedDetails
                                claimFor="claimSettlement"
                                claimNumber={this.state.claimDetails.warrantyClaimId}
                                claimTextEdit={this.claimTextEdit.bind( this )}
                                isComponentEdit={false}
                                userDesiredLng={this.state.userDesiredLng}
                                handleLanguage={this.updateLanguage.bind( this )}
                            />
                        </Accordion>
                        <Accordion
                            accordionId="basic-claim-information"
                            title="Analysis Comment"
                            isExpanded={false}
                        >
                            <ClaimAnalysis
                                claimFor="claimAnalysis"
                                claimNumber={this.state.claimDetails.warrantyClaimId}
                                primePartNumber={this.state.claimPartDetails}
                                updateClaim={this.updateClaimData.bind( this )}
                                enableEditCmp={this.enableEditCmp.bind( this )}
                                isComponentEdit={this.state.isClaimEditable}
                                isEdit={this.state.componentEditEnable === 'claimAnalysis'}
                            />
                        </Accordion>

                        <Accordion
                            accordionId="replacementPart-claim-information"
                            title="Replacement Part Information"
                            isExpanded={false}
                        >
                            <ReplaceMentPart
                                claimFor="claimReplacementParts"
                                claimNumber={this.state.claimDetails.warrantyClaimId}
                                claimTextEdit={this.claimTextEdit.bind( this )}
                                isComponentEdit={false}
                            />
                        </Accordion>
                        <Accordion
                            accordionId="Labor-claim-information"
                            title="Labor"
                            isExpanded={false}
                        >
                            <ReplaceMentPart
                                claimFor="claimLabor"
                                claimNumber={this.state.claimDetails.warrantyClaimId}
                                claimTextEdit={this.claimTextEdit.bind( this )}
                                isComponentEdit={false}
                            />
                        </Accordion>


                        <ConfirmationModal
                            body={<div className="confirmation-messages">Click {'Confirm'} to ignore the Edit in process and Continue</div>}
                            header="Warning"
                            isOpen={this.state.confirmIsOpen}
                            onCancel={this.handleConfirmClose}
                            onConfirm={this.handleConfirm.bind( this.props )}
                            onHide={this.handleConfirmClose}
                        />

                    </section>
                </div>
            </div>


        );

    }

}
ClaimDetails.displayName = 'ClaimDetails';
ClaimDetails.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    warrantyClaimId: PropTypes.string.isRequired,
    callFrom: PropTypes.string.isRequired,
    selectedClaimNumber: PropTypes.string.isRequired,
    claimDetailsInfo: PropTypes.object.isRequired,
    onBackToResult: PropTypes.func.isRequired,
    getPreviousClaimDetails: PropTypes.func.isRequired,
    getNextClaimDetails: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );
export default connect( mapStateToProps, mapDispatchToProps )( ClaimDetails );
